
import React from 'react'

export default ({ children }) => <pre>{ children.trim() }</pre>
